import { axiosService } from "../axios.service";
import { urls } from "../../constants";

const authService = {
  sendOtp: (data) =>
    axiosService.post(urls.auth.sendOtp, data).then((value) => value.data),
  verifyOtp: (data) =>
    axiosService.post(urls.auth.verifyOtp, data).then((value) => value.data),
  firebaseSignIn: (data) =>
    axiosService.post(urls.auth.firebaseSignIn, data).then((value) => value.data),
  getMe: () => axiosService.get(urls.auth.getMe).then((value) => value.data),
  logout: () =>
    axiosService.destroy(urls.auth.logout).then((value) => value.data),
  devices: () =>
    axiosService.get(urls.auth.devices).then((value) => value.data),
  logoutDevice: (deviceId) =>
    axiosService
      .destroy(urls.auth.logoutDevice, {
        params: {
          deviceId,
        },
      })
      .then((value) => value.data),
};

export { authService };
